import { render, staticRenderFns } from "./PermissionPanel.vue?vue&type=template&id=7329394a&"
import script from "./PermissionPanel.vue?vue&type=script&lang=ts&"
export * from "./PermissionPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports